import React, { useMemo } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import BottomNav from './BottomNav';

function getUserInitials(user) {
  if (!user) return '?';
  const name = user.displayName?.trim();
  if (name) {
    const parts = name.split(/\s+/).filter(Boolean);
    if (parts.length >= 2) {
      return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
    }
    return name.slice(0, 2).toUpperCase();
  }
  const email = user.email || '';
  if (email.length >= 2) return email.slice(0, 2).toUpperCase();
  return '?';
}

function IconBell({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13.73 21a2 2 0 0 1-3.46 0" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default function Layout() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const initials = useMemo(() => getUserInitials(user), [user]);

  return (
    <div className="flex min-h-screen flex-col bg-surface">
      {process.env.REACT_APP_FIREBASE_PROJECT_ID !== 'padel-ranking-58f86' && (
        <div className="fixed top-0 left-0 right-0 z-[100] bg-yellow-500 text-black text-center text-xs font-bold py-1">
          ⚠️ STAGING — {process.env.REACT_APP_FIREBASE_PROJECT_ID}
        </div>
      )}
      <header
        className="sticky top-5 z-[90] flex h-14 shrink-0 items-center justify-between gap-3 px-4 text-brand-ice"
        style={{ backgroundColor: '#0A2A6E' }}
      >
        <button
          type="button"
          onClick={() => navigate('/')}
          className="font-display text-lg font-semibold tracking-wider text-brand-ice focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#38BDF8] focus-visible:ring-offset-2 focus-visible:ring-offset-[#0A2A6E]"
        >
          MATA<span style={{ color: '#38BDF8' }}>DEL</span>
        </button>
        <div className="flex items-center gap-2">
          <button
            type="button"
            className="flex h-10 w-10 items-center justify-center rounded-full text-brand-ice/90 transition-opacity hover:opacity-80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#38BDF8]"
            aria-label="Notifiche (in arrivo)"
            title="Notifiche — prossimamente"
            onClick={() => {}}
          >
            <IconBell className="h-6 w-6" />
          </button>
          <button
            type="button"
            onClick={() => navigate('/profile')}
            className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#38BDF8]/20 text-sm font-semibold text-[#38BDF8] ring-1 ring-[#38BDF8]/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#38BDF8]"
            aria-label="Profilo"
          >
            {initials}
          </button>
        </div>
      </header>
      <main className="flex-1 px-4 py-4 pb-20">
        <Outlet />
      </main>
      <BottomNav />
    </div>
  );
}
